import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";

import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewOperationsStrategicTasksGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OPERATIONS_STRATEGIC_TASKS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createOperationsStrategicTasksGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OPERATIONS_STRATEGIC_TASKS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageOperationsStrategicTasksGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OPERATIONS_STRATEGIC_TASKS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

const ITEM_TYPES = [Constants.OPERATIONS, Constants.STRATEGIC_TASKS].map(String);

export const operationStrategicTaskItemTypeGuard: CanActivateFn = (route): boolean | UrlTree => {
  const router = inject(Router);
  const itemType = route.paramMap.get("itemType") ?? "";

  if (ITEM_TYPES.includes(itemType)) return true;
  return router.createUrlTree(["/console/operations-strategic-tasks"]);
};
